export default __webpack_public_path__ + "f247b6e9e672e58129e4b25455bffc69.jpg";